import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { GridStack } from "gridstack";
import { useTranslation } from 'react-i18next';
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
//import ResourceTable from "./ResourceList/ResourceTable/ResourceTable";
import DMSHeader from "../DMSHeader/DMSHeader";
import MasterResourceTable from "./MasterResourceTable/MasterResourceTable";
const MasterResourceManagement = (props) => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    GridStack.init();
  }, []);
  const location = useLocation();
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title={t('master_resource_management_header')}
          showdownload={true}
          fileName="MasterResource"
          showImportDropDownLabel={false} />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      component: <MasterResourceTable />,

    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default MasterResourceManagement;
